import { gsap } from 'gsap';

const init = () => {
  const container = document.querySelector('.l-container');
  // Lenisのスクロールを無効化
  if (window.lenis) {
    window.lenis.stop();
  }
  const mvVideo = document.querySelector('.js-mvVideo');

  function loadVideo(video) {
    const src = video.getAttribute('data-src');
    if (!src) {
      return;
    }
    video.src = src;
    video.removeAttribute('data-src');
  }
  loadVideo(mvVideo);

  function waitForImage(img) {
    return new Promise((resolve, reject) => {
      if (img.complete && img.naturalHeight !== 0) {
        resolve();
        return;
      }

      img.addEventListener('load', () => resolve(), { once: true });
      img.addEventListener('error', () => reject(new Error('Image load failed')), { once: true });
    });
  }


  const mvOverlay = document.querySelector('.js-mvOverlay');
  const mvOverlayText = document.querySelector('.js-mvOverlayText');
  const mvOverlayImage = mvOverlayText.querySelector('img');

  function splashAnimate() {
    let mvAnimated = sessionStorage.getItem('mvAnimated');
    // if (mvAnimated === 'true') {
    //   mvOverlay.style.display = 'none';
    //   window.lenis.start();
    //   container.classList.add('is-loaded');
    //   return;
    // }

    let mvTl = gsap.timeline({ delay: 0.4 });

    mvTl
    // .to(mvOverlayText, {
    //   clipPath: "inset(0% 0% 0% 0%)",
    //   ease: "power3.inOut",
    //   duration: 0.6,
    // })
    .to(mvOverlay, {
      "--overlay-clippath-top" : "100%",
      ease: "power1.inOut",
      duration: 0.6,
    })
    .to(mvOverlay, {
      "--overlay-clippath-bottom" : "100%",
      ease: "power1.inOut",
      duration: 0.48,
    }, '-=0.125')
    .to(mvOverlay, {
      duration: 0.4,
      ease: "power1.inOut",
      clipPath: 'inset(0% 0% 100% 0%)',
      onComplete: () => {
        mvOverlay.style.display = 'none';
        sessionStorage.setItem('mvAnimated', 'true');
        if (window.lenis) {
          window.lenis.start();
        }
        if (container) {
          container.classList.add('is-loaded');
        }
      }
    }, '+=0.5');
  }

  waitForImage(mvOverlayImage).then(splashAnimate);
};

export {
  init,
};